import { InputLabel, StandardTextFieldProps, TextField } from '@mui/material';
import { ChangeEvent } from 'react';
import {
  Controller,
  ControllerProps,
  FieldError,
  FieldValues,
  get,
  useFormContext,
  useFormState
} from 'react-hook-form';
import { PatternFormat, PatternFormatProps } from 'react-number-format';

import InputError from './InputError';

interface Props<T extends FieldValues>
  extends Omit<ControllerProps<T>, 'render'>,
    Omit<PatternFormatProps<StandardTextFieldProps>, 'defaultValue' | 'name'> {
  errors?: FieldError | string;
}

export const PatternInput = <T extends FieldValues>(props: Props<T>) => {
  const { errors: formErrors, name, type, label, ...inputProps } = props;
  const { control } = useFormContext<T>();
  const formState = useFormState({ control });
  const error = get(formState.errors, name);

  return (
    <>
      <InputLabel>{label}</InputLabel>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <PatternFormat
            {...inputProps}
            fullWidth
            type={type}
            sx={{ marginTop: 1 }}
            customInput={TextField}
            value={field.value ? field.value : ''}
            color={error ? 'error' : 'primary'}
            onValueChange={(values, source) => {
              if (source.event) {
                const { event } = source;
                const { value, formattedValue } = values;

                const changeEvent: ChangeEvent<HTMLInputElement> = {
                  ...event,
                  target: {
                    ...event.currentTarget,
                    value: type === 'text' ? value : formattedValue
                  }
                };

                field.onChange(changeEvent);
              }
            }}
          />
        )}
      />
      <InputError error={error ?? formErrors} />
    </>
  );
};
